module.exports = __webpack_public_path__ + "img/学校文字.e7a27c4e.png";